<template>
  <div>
    <v-dialog ref="dialog" v-model="menu" width="290px">
      <template v-slot:activator="{ on }">
        <div v-if="readonly">
          <slot v-bind="{ computedDate: computedDate }"></slot>
        </div>
        <div v-else v-on="on">
          <slot v-bind="{ computedDate: computedDate }"></slot>
        </div>
      </template>
      <v-date-picker v-model="date" scrollable @input="onInput" v-bind="$props">
        <!-- <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(date)">
          OK
        </v-btn> -->
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    value: {
      default: undefined,
    },
    min: {
      default: undefined,
    },
    max: {
      default: undefined,
    },
    allowedDates: {
      default: undefined,
    },
    readonly: {
      default: false,
    },
    format: {
      default: "DD/MM/YYYY",
    },
  },
  data() {
    return {
      date: this.value,
      menu: false,
    };
  },
  computed: {
    computedDate() {
      return this.value ? moment(this.value).format(this.format) : this.value;
    },
  },
  methods: {
    onInput(date) {
      this.menu = false;
      this.$emit("input", date);
    },
  },
};
</script>

<style lang="scss" scoped></style>
